<template>
  <div id="demo-basic-card">
    <div class="card-view">
      <div class="vx-row">
        <div class="vx-col md:w-1/3 w-full mt-2">
          <h3 class="ml-10">Tương tác nổi bật</h3>
          <label class="text-font ml-10">Nội dung thịnh hành trên mạng xã hội</label>
        </div>
        <div class="vx-col md:w-1/2 w-full mt-2">

        </div>
        <div class="vx-col md:w-1/6 w-full mt-2">
          <v-select
            v-model="timeSelect"
            :clearable="false"
            :options="timeOptions"
            data-vv-validate-on="input"
            name="time"
            v-validate="'required'"
          ></v-select>
          <span class="text-danger text-sm">
                    {{errors.first("time")}}
              </span>
        </div>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full sm:w-1/2 lg:w-1/3 mb-base" v-for="(card, index) in this.cards" :key="card.value">
        <vx-card @click="viewDetail(card.link)" style="cursor: pointer;">
          <div slot="no-body">
            <img style="height: 250px" :src="card.img" alt="content-img" class="responsive card-img-top">
          </div>
          <div class="text">
            <h5 class="mb-2">
              <feather-icon icon="FacebookIcon"
                            class="p-2 shadow-drop rounded-lg d-theme-dark-bg facebook-icon"></feather-icon>
              {{ card.title }}
            </h5>
            <p class="text-grey item-description text-sm">{{ card.subtitle }}</p>
            <p class="text-grey item-description text-sm">{{ card.subtitle_2 }}</p>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  import vSelect from 'vue-select'

  export default {
    data() {
      return {
        valueSelect:null,
        timeOptions:[
          {label:'3 ngày qua', value:3},
          {label:'7 ngày qua', value:7},
          {label:'1 tuần qua', value:30}
        ],
        // card 1
        cards: [],
        settings: { // perfectscrollbar settings
          maxScrollbarLength: 60,
          wheelSpeed: .60,
        },
      }
    },
    components: {
      VuePerfectScrollbar,
      vSelect
    },
    computed: {
      validateForm: function () {
        return !this.errors.any();
      },
      timeSelect: {
        get() {
          let object = this.timeOptions.find(el => el.value === this.valueSelect);
          if (!object) {
            return {
              label: this.timeOptions[0].label,
              value: this.timeOptions[0].value
            }
          }
          return {
            label: object.label,
            value: this.valueSelect
          }
        },
        set(val) {
          this.valueSelect = val.value;
        }
      }
    },
    mounted() {
    },
    created() {
      for (let i = 0; i < 20; i++) {
        this.cards.push({
          value: i,
          img: require("@/assets/images/pages/content-img-1.jpg"),
          subtitle: " Cụ Năm Lại năm nay 71 tuổi, nhà ở gần đồi cát Mũi Né, thành phố Phan Thiết. Cụ nói: \"Tôi rất nghèo, ở nhà tình thương, lại có đứa con bị bệnh tim nên tôi hàng ngày vẫn leo đồi cát cho thuê miếng trượt kiếm sống. Mỗi miếng ván trượt cho thuê với giá từ 20.000đ- 30.000 đ/giờ”.",
          subtitle_2: " Với hơn 30 năm kinh nghiệm trượt trên đồi cát, cụ Năm Lại thường hướng dẫn du khách cách chơi ván trượt với nhiều kiểu khác nhau.",
          title: "KHÓ KHĂN KHÔNG LÀM MẤT ĐI NỤ CƯỜI CỦA NHỮNG NGƯỜI MƯU SINH ‼",
          link: "https://www.facebook.com/"
        });
      }
    },
    methods:{
      viewDetail(link){
        window.open(link, '_blank');
      }
    }
  }
</script>

<style lang="scss">
  #demo-basic-card {
    .overlay-card {
      .vx-card__collapsible-content {
        max-height: 485px;
      }
    }

    .chat-card-log {
      height: 360px;

      .chat-sent-msg {
        background-color: #f2f4f7 !important;
      }
    }

    .card-video {
      .video-js {
        height: 370px;
      }
    }

    .facebook-icon {
      background-color: #3B5998;
      color: white;
      margin-right: 5px;
      border-radius: 50%;
      width: 30px;
      height: 30px;
      border-radius: 70%;
    }

    .text {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 6; /* number of lines to show */
      -webkit-box-orient: vertical;
    }

    .card-view {
      border-radius: 10px;
      padding: 5px 10px 10px 10px;
      box-shadow: 0px 4px 25px 0px rgba(95, 94, 94, 0.1);
      -webkit-transition: all 0.3s ease-in-out;
      margin-top: -20px;
      margin-bottom: 30px;
    }
  }
</style>
